document.addEventListener("DOMContentLoaded", function () {
  window.header = {
    _DEFAULT_ESTORES: {
      '/us/en/home.html': 'estore-scientific',
      '/us/en/healthcare-products.html': 'estore-healthcare',
      '/us/en/education-products.html': 'estore-scied'
    },
    hdaImpersonate: {
        init: function(){
          var checkDetailLimit = 50;
          var checkDetailCount = 0;
          var banner = document.querySelector('#fs-headerfooter-hbr');
          var impersonate = document.querySelector('.hda-impersonate');
          var shim = document.querySelector('#header-shim');
          var checkUserDetails = setInterval(function() {
            checkDetailCount++;
            if(typeof window.accountDropdown !== 'undefined'){
              if(typeof window.accountDropdown.userDetails !== 'undefined' && !window.accountDropdown.userDetails.userIsPunchOut){
                if(window.accountDropdown.userDetails.hdaUserImpersonateRole){
                  //Show banner, add additional margin to shim
                  impersonate.classList.remove('hide');
                  shim.setAttribute('style','margin-bottom: 152px');

                  //test for ad banner, if it's there, make further adjustments
                  if(banner.hasChildNodes()){
                    impersonate.style.top = '137px';
                    shim.style.marginBottom = '192px';
                  }

                  document.querySelector('.hda-impersonate > button').addEventListener('click', function() {
                    fetch('/store1/users/service/logoff', {
                      method: 'DELETE',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        userName: window.accountDropdown.userDetails.logonId
                      })
                    })
                        .then(function(response) {
                          return response.json();
                        })
                        .then(function(hdaLogoffData) {
                          console.log('status for logoff:: ', hdaLogoffData);
                          document.location.href = window.accountDropdown.userDetails.redirectUrl;
                        })
                        .catch(function(error) {
                          console.log('error status for logoff:: ', error.status);
                        });
                  });
                  if(typeof window.accountDropdown.userDetails.hdaUsername !== 'undefined'){
                    document.querySelector('#impersonatedUserName').innerText = window.accountDropdown.userDetails.hdaUsername;
                  }
                  clearInterval(checkUserDetails);
                } else {
                  clearInterval(checkUserDetails);
                }
              }
            } else {
              if(checkDetailCount > checkDetailLimit){
                clearInterval(checkUserDetails);
              }
            }
          }, 500);
        }
    },
    login: {
      loginHref:  '/store1/users/service/loginmodal' ,
      loginModal: function(){
        if(window.utils.getCookie(env.identityCookieName)){
          document.location = env.identitySigninURI;
          return;
        }
        $.colorbox({
          href: window.header.login.loginHref,
          width: '335px'
        });
      },
      _loginEnterKey: function(){
        var signInForm = document.getElementById("signInForm");
        if (signInForm) {
          signInForm.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
              document.querySelector('#qa_session_expire_extend').click();
            }
          });
        }
      },
      init: function(){

        document.addEventListener("click", function(event) {
          var target = event.target;

          if (target.classList && (target.classList.contains("btn-sign-in") || target.classList.contains("sign-in-modal"))) {
            event.preventDefault();
            var isGuest = window.utils.getCookie('usertype').toUpperCase() === 'G';

            if (target.classList.contains("sign-in-modal") && !isGuest) {
              return true;
            }

            var calloutContainers = document.querySelectorAll('.callout-container');
            Array.from(calloutContainers).forEach(function(container) {
              container.remove();
            });

            if (typeof Common !== 'undefined') {
              Common.callOutOpen = "";
            }

            var newLocation = "";
            var loginRequestedPage = target.getAttribute("href");
            window.utils.setCookie("loginRequestedPage", (target.classList.contains("sign-in-modal") ? loginRequestedPage : ""), { path: "/" });

            if (window.location.protocol.toLowerCase().indexOf("s") < 0) {

              if (window.location.href.indexOf("modal=login") < 0) {
                newLocation = ((window.location.href.indexOf("?") > -1) ? "&" : "?") + "modal=login";
              }

              var protocolToUse = (document.location.href.toLowerCase().indexOf("localhost") > -1) ? 'http:' : 'https:';
              window.location.href = (window.location.href.replace(/http:/gi, protocolToUse) + newLocation);
            } else {
              window.header.login.loginModal();
            }
            return false;
          }
        });

        if(document.location.href.indexOf("modal=login")>-1){
          window.header.login.loginModal();
        }
      },
      newVisitorUpdate: function() {
        var attempts = 10; // If not ready after 10 attempts, stop
        var menuSelector = document.querySelector('.create-acc-cls');
        var signInButton = document.getElementById('signIn');
        var menuContainer = document.querySelector('.menuContainer');
        var accountLink = document.getElementById('account-dd-link');

        var checkNewRepeat = setInterval(function () {
          attempts--;

          if (window.userfunctions.userIsNewVisitor() && menuSelector) {
            menuSelector.parentElement.classList.add('text-align-center');
            menuSelector.parentElement.innerHTML = '<span>Already have an account? <a class="btn-sign-in" href="javascript:void(0);">Sign In</a></span>';
            accountLink.innerText = 'Register for an Account';
            signInButton.innerText = 'Register for an Account';
            signInButton.setAttribute('href','/store1/users/userregistration');
            signInButton.classList.remove('btn-sign-in');
            signInButton.classList.add('dynamic-update');
            menuContainer.classList.add('menuContainer--dynamic-update');
            clearInterval(checkNewRepeat);
          }

          if (attempts === 0 || window.userfunctions.userIsNewVisitor()) {
            clearInterval(checkNewRepeat);
          }
        }, 1000);
      }
    },
    navigation: {
      estoreSelector: document.querySelector('#eStoreSelect-desktop'),
      estoreSelectorNoDesktop: document.querySelector('#eStoreSelect-no-desktop'),
      open: function () {
        window.header.navigation.container.classList.add("open");
        window.header.navigation.bg.classList.add("open");
      },
      //Close accordions if main nav is closed
      closeAccordion: function() {
        const openAccordion = document.querySelector('.list-item.accordion.open');
        if (openAccordion) {
          openAccordion.classList.remove('open');
        }
      },
      updateEstore: function(event){
        var element = event.currentTarget;
        var nodeName = element.nodeName;
        var url;
        var cookie;
        var cookieOptions = {};

        event.preventDefault();

        //handle elements differently
        if(nodeName && nodeName.toUpperCase() === 'SELECT'){
          element = event.currentTarget.options[event.currentTarget.selectedIndex];
        }

        url = element.getAttribute('data-url');
        cookie = element.getAttribute('data-estore-cookie');

        if(window.utils.getCookie("estore") !== cookie){

          if(url !== null && cookie !== null){
            cookieOptions = {
              expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
              path: '/',
              secure: true
            };
            window.utils.setCookie("estore", cookie, cookieOptions);
            window.location.href = url;
          }
        } else {
          $.colorbox.close();
        }

        try{
          digitalDataManager.fishersci.setStore()
        }catch (e)  {
          console.error("Error setting store in digitalDataManager: ", e);
        }
      },
      init: function () {
        var closeIcons;
        var cartIconLink = document.getElementById('cart-link-a');
        var customHomeCookie;
        var hasCustomHome;
        var isCMSEnabled;

        if (LocalePath.getCountry().toUpperCase() === "US"){
          window.domUtils.waitForElement('#eStoreSelect-desktop', function () {
            var estoreSelector = document.querySelector('#eStoreSelect-desktop');
            estoreSelector.addEventListener("change", window.header.navigation.updateEstore);
          });

          window.domUtils.waitForElement('#eStoreSelect-no-desktop', function () {
            var estoreSelectorNoDesktop = document.querySelector('#eStoreSelect-no-desktop');
            estoreSelectorNoDesktop.addEventListener("change", window.header.navigation.updateEstore);
          });
        }

        // Handle scenario where custom home user logs out - make sure they get new home page when redirected to home
        window.domUtils.waitForElement('.signOut', function () {
          document.querySelector('.signOut').addEventListener('click', function () {
            window.utils.deleteCookie('customHome');
          })
        });


        //Icon listeners
        window.domUtils.waitForElement('#mega-nav', function () {
          var closeIcons = document.querySelectorAll('.close-main-drawer');
          for (var i = 0; i < closeIcons.length; i++) {
            closeIcons[i].addEventListener('click', function() {
              window.header.navigation.closeAccordion();
            });
          }
        });
        //Handle DOM updates due to caching
        if(cartIconLink) {
          if (window.utils.getCookie('new_cart') === 'true' || LocalePath.getCountry().toUpperCase() === "US") {
            cartIconLink.setAttribute('data-remote-url', '/store1/cart/cartlet/?language=' + LocalePath.getLanguage() + '&countryCode=' + LocalePath.getCountry().toUpperCase());
            cartIconLink.removeAttribute('data-remote-callback-function');
            cartIconLink.href = '/store1/cart/?language=' + LocalePath.getLanguage() + '&countryCode=' + LocalePath.getCountry().toUpperCase();
          } else {
            //Default to the old cart
            cartIconLink.href = '/shop/orderdisplayview';
            cartIconLink.setAttribute('data-remote-url', '/shop/jsoncartlet?nocache=' +Date.now());
            cartIconLink.setAttribute('data-remote-failure-url', '/shop/orderdisplayview');
            cartIconLink.setAttribute('data-remote-callback-function', 'convertCartJsonToHtml');
          }
        }
        try {
          //Update account link dynamically due to caching and remove the mobile login box if user isn't a guest
          switch(window.utils.getCookie('usertype')){
            case "G":
              document.getElementById('account-dd-span').innerText = linkTranslations.signIn;
              document.querySelector('#main-nav-header').setAttribute('data-logged-in', false);
              if(LocalePath.getCountry().toLowerCase() === 'ca'){
                document.getElementById('quickorder-link-a').classList.add('btn-sign-in');

                setTimeout(function() {
                  // Add login class to any links with data-requires-login attribute
                  var links = document.querySelectorAll('[data-requires-login]');
                  for (var i = 0; i < links.length; i++) {
                    links[i].classList.add('btn-sign-in');
                  }

                  var hideForGuestsInMobile = document.querySelectorAll('[data-hide-for-guests]');
                  // Mainly for Accounts section
                  for (var j = 0; j < hideForGuestsInMobile.length; j++) {
                    hideForGuestsInMobile[j].classList.add('d-none');
                  }
                }, 1000);

              }

              break;
            case "R":
            case "M":
            case "P":
              document.querySelector('#main-nav-header').setAttribute('data-logged-in', true);
              document.getElementById('account-dd-span').innerText = linkTranslations.account;
              window.domUtils.waitForElement('.sign-in-button--non-mobile', function () {
                document.querySelector('.sign-in-button--non-mobile').remove();
              });
              break;
            default:
              document.getElementById('account-dd-span').innerText = linkTranslations.account;
              break;
          }
          //Handle persistent
          if(window.utils.getCookie('usertype') === 'G' && typeof window.utils.getCookie('persistentUser') !== "undefined" && window.utils.getCookie('persistentUser') !== '' ){
            document.getElementById('account-dd-span').innerText = linkTranslations.account;
            document.querySelector('#main-nav-header').setAttribute('data-logged-in', true);
            window.domUtils.waitForElement('.sign-in-button--non-mobile', function () {
              document.querySelector('.sign-in-button--non-mobile').remove();
            });
          }
        }catch (e){
          console.log(e.message);
        }
        //Add ie version to <header>
        if(document.documentMode){
          document.body.classList.add('ie' + document.documentMode);
        }

        //Add listener to logo to redirect to custom home page
        //true|true|/us/en/customhomes/7000000000001089669.html
        if(env.customHomeRedirectEnabled){
          customHomeCookie = window.utils.getCookie('customHome');
          if(customHomeCookie){
            customHomeCookie = customHomeCookie.split('|');
            hasCustomHome = customHomeCookie[0] === 'true' || false;
            isCMSEnabled = customHomeCookie[1] === 'true' || false;
            if(customHomeCookie.length > 2){
              if(hasCustomHome){
                if(customHomeCookie[2] && customHomeCookie[2].indexOf('/custom-homes/') > 0)
                document.querySelector('.logo').addEventListener('click', function(e){
                  e.preventDefault()
                  window.location.href = '/' + LocalePath.getCountry().toLowerCase() + '/' + LocalePath.getLanguage().toLowerCase() + '/myhomepage.html';
                });
              }

              //Waiting for URLS
              if( !hasCustomHome && !isCMSEnabled ){
                //TODO - send user to generic customer home page
              }
            }
          }
        }
      },
      updateLegacyLinks: function(selector, newUrl){
        selector.forEach(function(element) {
          element.href = newUrl;
        });
      }
    },
    uiElements : {
      background : document.querySelector("#full-bg"),
      createCoreNotifications: function(options) {
        let notificationOptions = {
          label: 'Test Label',
          message: 'Test Message',
          testId: 'core-notification',
          variant: 'inline',
          state: 'information',
          reusable: 'true',
          nostateicon: 'true',
          target: '',
          slot: 'content'
        };
        //Merge options
        if (options && typeof options === 'object') {
          notificationOptions = Object.assign({}, notificationOptions, options);
        }
        const coreNotification = document.createElement('core-notification');
        coreNotification.setAttribute('data-testid', notificationOptions.testId);
        coreNotification.setAttribute('label', notificationOptions.label);
        coreNotification.setAttribute('message', '');
        coreNotification.setAttribute('variant', notificationOptions.variant);
        coreNotification.setAttribute('state', notificationOptions.state);
        coreNotification.setAttribute('reusable', notificationOptions.reusable);
        coreNotification.setAttribute('nostateicon', notificationOptions.nostateicon);

        // Create the <span> element
        const slotElement = document.createElement('span');
        slotElement.setAttribute('target', notificationOptions.target);
        slotElement.setAttribute('slot', notificationOptions.slot);
        slotElement.innerHTML = notificationOptions.message || '';

        // Append the <span> slot element to the core-notification element
        coreNotification.appendChild(slotElement);

        // Find the element with the ID "main-nav-header"
        const mainNavHeader = document.getElementById('main-nav-header');

        // Insert the new element and set its position
        if (mainNavHeader) {
          // Insert the new element into the body (or any other container)
          document.body.appendChild(coreNotification);

          // Get the position of the "main-nav-header" element
          const headerRect = mainNavHeader.getBoundingClientRect();

          // Set the styles for the new element
          coreNotification.style.position = 'absolute';
          coreNotification.style.right = '10px';
          coreNotification.style.zIndex = '1000';
          coreNotification.style.top = `${headerRect.bottom + 10}px`;
        }
      },
      repositionTooltip: function() {
        var countrySelector = document.getElementById('country-selector');
        var tooltip = document.getElementById('eu-tooltip-container');
        if (countrySelector && tooltip) {
          var rect = countrySelector.getBoundingClientRect();
          tooltip.style.top = (rect.top - 15) + 'px';
          tooltip.style.left = (rect.left - 45) + 'px';
        }
      },
      languageToolTip: function() {
        //Check if local storage value exists
        if(localStorage.getItem('languageToolTip') === null && localStorage.getItem('languageToolTipOverride') === null){
          //add bg
          window.header.uiElements.background.classList.add('open');
          document.getElementById('eu-tooltip-container').classList.remove('hide');
          //set the local storage value so we don't show again
          localStorage.setItem('languageToolTip', 'true');

          //close button listener
          document.querySelector('.close-button').addEventListener('click', function() {
            document.getElementById('eu-tooltip-container').remove();
            window.header.uiElements.background.classList.remove('open');
            window.removeEventListener('resize', window.header.uiElements.repositionTooltip);
          });

          //If the banner times out, add the class
          document.addEventListener('bannerTimeout', function(event) {
            document.getElementById('eu-tooltip-container').classList.remove('eu-banner-enabled');
            document.getElementById('eu-tooltip-container').classList.add('eu-banner-disabled');
            window.header.uiElements.repositionTooltip();
          });

          window.addEventListener('resize', window.header.uiElements.repositionTooltip);
          window.header.uiElements.repositionTooltip();

        } else {
          document.getElementById('eu-tooltip-container').remove();
        }
      }
    },
    cart: {
      link: document.querySelector("#cart-link"),
      link_a: document.querySelector("#cart-link-a"),
      count: document.querySelector("#cart-link .count"),
      bg: document.querySelector('#full-bg'),
      cartcontainer: document.querySelector('#cart-sidebar'),
      cartclose: document.querySelector('#cart-close'),
      show: function (args) {
        if (args["addToCart"]) {
          window.header.cart.addToCart({params: args["params"]});
        } else {
          window.header.cart.link.click();
        }
      },
      hide: function () {
        if(typeof window.header.cart.cartcontainer !== 'undefined'){
          window.header.cart.cartcontainer.classList.remove('open');
        }
      },
      addToCart: function (args) {
        var params = new URLSearchParams();
        params.set("addToCart", true);
        if (args["params"]) {
          for (let key in args["params"]) {
            params.set(key, args["params"][key]);
          }
        }
        window.header.cart.link.setAttribute("data-remote-url", window.header.cart.link.getAttribute("data-remote-url") + "?" + params);
        window.header.cart.link.click();
        window.header.cart.resetCartLink();
      },
      resetCartLink: function () {
        window.header.cart.link.setAttribute("data-remote-url", "/store1/cart/?language="+ LocalePath.getLanguage() + "&countryCode=" + LocalePath.getCountry().toUpperCase());
      },
      reArmCartLink: function() {
        window.header.cart.link_a.removeAttribute("data-remote-triggered");
      },
      updateCount: function (count) {
        if( window.header.cart.count ){
          window.header.cart.count.innerText = count;
        }
      },
      getCount: function(){
        var cartId = window.utils.getCookie('CART_ID');
        return  (typeof cartId !== 'undefined' && cartId !== '') ? cartId.split('_')[1] : '';
      },
      init: function () {
        if(window.header.cart.link !== undefined && window.header.cart.link !== null ){
          window.header.cart.link.addEventListener("click", function() {
            window.header.cart.cartcontainer.classList.add('open');
            window.header.cart.bg.classList.add('open');
          });
        }
        if(window.header.cart.cartcontainer !== undefined && window.header.cart.cartcontainer !== null ){
          document.addEventListener("click", function(event) {
            var target = event.target;
            //Close cart
            if (target.matches('.js-cart-close') || target.matches('.js-continue-shopping')) {
              window.header.cart.link.click();
            }
          });
        }
        //Events for clicking background with drawers, modals, etc..
        if(window.header.uiElements.background !== undefined && window.header.uiElements.background !== null ){
          window.header.uiElements.background.addEventListener("click", function() {
            window.header.cart.hide();
            if(document.querySelectorAll('.drawer.open') !== undefined && document.querySelectorAll('.drawer.open').length > 0){
              Array.from(document.querySelectorAll('.drawer.open')).forEach(function(drawer){
                drawer.classList.remove('open');
              })
              Array.from(document.querySelectorAll('.list-item--text')).forEach(function(listItem){
                listItem.classList.remove('active');
              });
            }
            this.classList.remove('open');//Close the background

            //Close any drawers left open
            if(document.querySelector('.list-item.accordion.open')){
              document.querySelector('.list-item.accordion.open').classList.remove('open');
            }
            Array.from(document.querySelectorAll('.remove-on-bg-click')).forEach(function(el){
              el.remove();
            });

          });
        }
        //Don't get the count for confirmation pages
        if(window.utils.getCookie('new_cart') ==='true' && document.location.href.indexOf('/checkout/confirmation/') === -1){
          window.header.cart.updateCount(window.header.cart.getCount());
        }
      },
      convertCartJsonToHtml:  function(data){ //This will be a temporary change for Canada and certain B2B EU
        var cartlet;
        var json = JSON.parse(data.response);
        var totalProducts = 0;
        var cartSidebar = document.getElementById('cart-sidebar');


        //Handle EU
        if(json.basketitems && json.basketitems.length > 0){
          totalProducts = 0;
          json.cartTotal = json.total;

          //update cart count
          json.basketitems.forEach(function(item){
            totalProducts += parseInt(item.nb);
          })
          json.totalLineItems = totalProducts;
          window.header.cart.updateCount(totalProducts);

        } else {
          json.cartTotal = 0;
        }

        cartlet = Handlebars.templates['cartlet/cartlet'](json);
        cartSidebar.innerHTML = cartlet;
      }
    },
    welcomeModal: {
      // When updating the homepages, ensure the _DEFAULT_ESTORES keys are also updated.
      homePages:  [
        '/us/en/home.html',
        '/us/en/healthcare-products.html',
        '/us/en/education-products.html'
      ],
      link: document.querySelectorAll(".get_started"),
      init:function (){


        var attempts = 20;
        var cookieOptions;
        var checkNewRepeat = setInterval(function () {
          attempts--;
          if (((window.utils.getCookie('estore') === undefined || window.utils.getCookie('estore') === '') || window.userfunctions.userIsNewVisitor()) && window.header.welcomeModal.homePages.indexOf(document.location.pathname) !== -1) {
            //Let's default to scientific the first time
            cookieOptions = {
              expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
              path: '/',
              secure: true
            };
            window.utils.setCookie("estore", window.header._DEFAULT_ESTORES[document.location.pathname], cookieOptions);

            if(!window.utils.getCookie('notice_gdpr_prefs')){
              document.body.addEventListener("truste-consent", window.header.welcomeModal.triggerWelcomeModal)
            } else {
              window.header.welcomeModal.triggerWelcomeModal();

            }
            //CLear check
            clearInterval(checkNewRepeat);
          } else {
            clearInterval(checkNewRepeat);
          }
          if (attempts === 0 || window.userfunctions.userIsNewVisitor()) {
            clearInterval(checkNewRepeat);
          }
        },200)
      },
      openModal : function(){
        $.colorbox({
          inline: true,
          href: "#welcome_modal_wrapper",
          width: '75%',
          onOpen: function () {
            document.querySelector('#colorbox').classList.add('welcome_modal_color_box');
          },
          onCleanup: function () {
            document.querySelector('#colorbox').classList.remove('welcome_modal_color_box');
          }
        });
      },
      addModalLinkEvents:function(){
        //Update links in modal set cookie on click
        for (var i = 0; i < window.header.welcomeModal.link.length; i++) {
          if (window.header.welcomeModal.link[i] !== undefined && window.header.welcomeModal.link[i] !== null) {
            window.header.welcomeModal.link[i].addEventListener("click", window.header.navigation.updateEstore)
          }
        }
      },
      triggerWelcomeModal: function(){
        document.body.removeEventListener("truste-consent", window.header.welcomeModal.triggerWelcomeModal);

        return; //Customer complaints about the estore modal - do everything else, just don't show it
        window.header.welcomeModal.openModal();
        window.header.welcomeModal.addModalLinkEvents();
      }
    },
    Chatbot: {
      init:function (){
        if(window.header.Chatbot.isChatbotEnabled()){
          let scriptElement  = document.createElement('script');

          //TODO Remove this logic , they only want this in QA right now
          if(window.header.Chatbot.getLauncherScriptDomain()){
            scriptElement.setAttribute("type", "text/javascript");
            scriptElement.setAttribute('src', window.header.Chatbot.getLauncherScriptDomain()+"/search/chat-launcher/chat-launcher.js");
            document.body.appendChild(scriptElement);
          }
        }
      },
      isChatbotEnabled : function () {
        var currentURL = window.location.href;
        var disabledPaths = [];

        for (var i = 0; i < disabledPaths.length; i++) {
          var path = disabledPaths[i];
          if (currentURL.indexOf(path) !== -1) {
            return false; // URL matches a disabledPaths path
          }
        }
        return true;
      },
      getLauncherScriptDomain : function () {
        var baseUrl = (window.location.hostname.indexOf('qa') === 0 || window.location.hostname.indexOf('localhost') === 0)
            ? "https://qa1-chat-api.fishersci.com"
            : "https://chat-api.fishersci.com";

        return baseUrl;
      }
    },
    countrySelector: {
      init: function(){
        if(window.utils.getCookie('locale') === 'en_US'){
          return;
        }
        //Handle non-US regions
        var languageRadios = document.querySelectorAll('[name="language-selection"]:not(:checked)');
        var countrySelectors = document.querySelectorAll('.js-country-selector:not(.selected)');
        var cookieOptions = {
          expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
          path: '/',
          secure: true
        };
        if (languageRadios) {
          for (var i = 0; i < languageRadios.length; i++) {
            languageRadios[i].addEventListener('click', function() {
              window.utils.setCookie("locale", this.getAttribute('data-locale-cookie'), cookieOptions);
              window.header.countrySelector.changeLanguage(this);
            });
          }
        }

        if (countrySelectors) {
          for (var j = 0; j < countrySelectors.length; j++) {
            countrySelectors[j].addEventListener('click', function(e) {
              e.preventDefault();
              window.header.countrySelector.changeCountry(this);
            });
          }
        }
      },
      changeCountry: function(el){
        fisherDataLayer.generalData.pageType = '';
        fisherDataLayer.eventAction='Change Country';
        fisherDataLayer.eventLocation='Country/Language Selector';
        fisherDataLayer.generalData.country= el.getAttribute('data-current-country');
        _satellite.track('Change_Country');
        setTimeout(function () {
          document.location.href = el.getAttribute('href');
          },500);
      },
      changeLanguage: function(el){
        var hashValue;
        var url;
        var updatedUrl;
        var newLocale = el.getAttribute('data-locale-cookie');
        var splitLocalePath = newLocale.split('_');
        var newLanguage = splitLocalePath[0].toLowerCase();
        var reloadPage = true;
        let pageValue, pageNumber;

        var _sendAnalytics = function(){
          //fisherDataLayer.generalData.pageType = '<provide correct page type>';
          fisherDataLayer.eventAction='Change Language';
          fisherDataLayer.eventLocation='Country/Language Selector';
          fisherDataLayer.generalData.language=newLanguage; //e.g.: Italian - IT
          if(typeof _satellite !== 'undefined'){
            _satellite.track('Change_Language');
          }
        }

        //to prevent tooltip from showing if switching to EN
        if(newLanguage === 'en'){
          localStorage.setItem('languageToolTipOverride', 'true');
        } else {
            localStorage.removeItem('languageToolTipOverride');
        }

        if(window.location.hash){
          hashValue = window.location.hash;
          url = fishersci.util.QueryString.update(window.location.href.substr(0, window.location.href.indexOf('#')),"change_lang",true);
        }
        else{
          url = fishersci.util.QueryString.update(window.location.href,"change_lang",true);
        }


        if(fishersci.util.QueryString.getByKey('language')){
          url = fishersci.util.QueryString.update(url,'language',newLanguage);
          reloadPage = false;
        }

        if(fishersci.util.QueryString.getByKey('countryCode')){
          var newCountryCode = splitLocalePath[1].toUpperCase();
          url = fishersci.util.QueryString.update(url,'countryCode',newCountryCode);
          reloadPage = false;
        }

        if(fishersci.util.QueryString.getByKey('page')){
            pageValue = fishersci.util.QueryString.getByKey('page');
            pageNumber = Number(pageValue);
          if (!Number.isNaN(pageNumber) && pageValue !== null && pageValue !== '') {
            url = fishersci.util.QueryString.update(url, 'page', 1);
          } else {
            url = fishersci.util.QueryString.update(url, 'page', pageValue);
          }
        }

        if(hashValue!=="" && hashValue!==undefined){
          updatedUrl = url+hashValue;
          if(window.location.href === updatedUrl && reloadPage === true ){
            setTimeout(function () {
              _sendAnalytics(newLanguage)
                window.location.reload();
            },500);

          }else {
            setTimeout(function () {
              _sendAnalytics(newLanguage)
              window.location.href = updatedUrl;
            }, 500);
          }

        }else{
          setTimeout(function () {
            _sendAnalytics(newLanguage)
            window.location.href = url;
          },500);
        }
      }
    },
    account: {
      convertAccountJsonToHtml : function (data){
        var json = JSON.parse(data.response);
        var accountContainer = document.getElementById('account-container');
        var accountHtml = json.userDetails.loggedIn ? Handlebars.templates['account-menu/_new-account-menu'](json) : Handlebars.templates['account-menu/_new-guest-account-menu'](json);

        accountContainer.innerHTML = accountHtml;

        //Expose JSON to render username above account links
        window.accountDropdown = json;

        //Update cart count ( legacy houses this in userDetails )
        if(json.userDetails.cartCount && !isNaN(json.userDetails.cartCount)){
          window.header.cart.updateCount(json.userDetails.cartCount);
        }
      },
      customAccountEvents: function(){
        // Fire custom event
        const event = new CustomEvent('accountNumberDefined', { detail: fisherDataLayer.userData.account });
        document.dispatchEvent(event);
      }
    }
  },
      window.customAccountEvents = window.header.account.customAccountEvents,
      window.convertCartJsonToHtml = window.header.cart.convertCartJsonToHtml,
      window.convertAccountJsonToHtml = window.header.account.convertAccountJsonToHtml,
      setTimeout(function() {
        window.header.navigation.init();
      },300);
  setTimeout(function() {
    var validChatbotCountries = ['us', 'ca', 'ie', 'gb'];
    window.header.cart.init();
    window.header.welcomeModal.init();
    if(document.location.host.indexOf('fishersci.ca') === -1){
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/global-ui/getconfig/chatbotEnabled', true);
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Parse the response JSON if applicable
          var responseData = JSON.parse(xhr.responseText);

          // If the flag is true, init the chatBot
          if (responseData.value === "true") {
            window.header.Chatbot.init();
          }
        } else {
          // Handle errors
          console.error('Request failed with status:', xhr.status);
        }
      };
      xhr.onerror = function() {
        console.error('Network error occurred');
      };
      xhr.send();
    }

    window.header.countrySelector.init();
    if(env.showLanguageToolTip){
      window.header.uiElements.languageToolTip();
    }


  }, 0);
  setTimeout(function() {
    window.header.login.init();
  }, 0);

  setTimeout(function() {
    window.header.login.newVisitorUpdate();
  }, 0);

  setTimeout(function() {
    window.header.hdaImpersonate.init();
  }, 0);
})

